import { createAtlasPaletteOptions } from "../utils/createAtlasPaletteOptions.js";
export const createPaletteOptions = (tokens) => {
    return createAtlasPaletteOptions(tokens);
};
//# sourceMappingURL=palette.js.map